import React from 'react';
import { GridColDef, GridRowModel } from '@mui/x-data-grid';
import { FGrid, FGridMoneyCell } from '../grid';

type Props = { rows: any[]; loading?: boolean; onChange: (rows: any[]) => void; onSubmit: (rows: any[]) => Promise<void> };
type State = { saving: boolean };

class PpmLinesGrid extends React.Component<Props, State> {
  state: State = { saving: false };

  columns: GridColDef[] = [
    { field: 'psc', headerName: 'Section', width: 140, editable: true },
    { field: 'ccc', headerName: 'CC', width: 110 },
    { field: 'acc', headerName: 'Account', width: 120 },
    { field: 'bga', headerName: 'Budget', width: 130, renderCell: FGridMoneyCell },
    { field: 'ara', headerName: 'Arrears', width: 120, type: 'number', editable: true },
    { field: 'avc', headerName: 'Available', width: 130, renderCell: FGridMoneyCell },
    { field: 'atx', headerName: 'Activity', flex: 1, minWidth: 280, editable: true },
    { field: 'pnt', headerName: 'Nature', width: 180, editable: true },
    { field: 'pmd', headerName: 'Method', width: 140, editable: true },
    { field: 'rvt', headerName: 'Review', width: 120, editable: true },
    { field: 'tpd', headerName: 'Publication', width: 140, editable: true },
    { field: 'bsd', headerName: 'Bid Deadline', width: 140, editable: true },
    { field: 'evd', headerName: 'Eval Days', width: 110, type: 'number', editable: true },
    { field: 'psd', headerName: 'Start', width: 130, editable: true },
    { field: 'exd', headerName: 'Exec Days', width: 110, type: 'number', editable: true },
    { field: 'eed', headerName: 'End', width: 130, editable: true },
    { field: 'lot', headerName: 'Lot', width: 100, editable: true },
    { field: 'ruc', headerName: 'Responsible', width: 150, editable: true },
    { field: 'san', headerName: 'Superactivity', width: 180 },
  ];

  processRowUpdate = (newRow: GridRowModel) => {
    const rows = (this.props.rows || []).map((r: any) =>
      String(r.rid || r.id) === String(newRow.rid || newRow.id)
        ? { ...r, ...newRow, _state: 'dirty' }
        : r
    );
    this.props.onChange(rows);
    return rows.find((r: any) => String(r.rid || r.id) === String(newRow.rid || newRow.id)) || newRow;
  };

  saveAll = async () => {
    this.setState({ saving: true });
    try { await this.props.onSubmit(this.props.rows || []); }
    finally { this.setState({ saving: false }); }
  };

  render() {
    return (
      <FGrid
        title="PPM Lines"
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading || this.state.saving}
        height={560}
        saveAll={this.saveAll}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#e7f6ea' }}
        getRowId={(row: any) => row.rid || row.id}
        processRowUpdate={this.processRowUpdate}
        pageSizeOptions={[25, 50, 100]}
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
      />
    );
  }
}
export default PpmLinesGrid;
